import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const CornerRightUpIcon = (props?: SvgProps) => (
  <svg
    height="20"
    width="20"
    fill="none"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M3.33398 16.6654V15.4987C3.33398 12.6984 3.33398 11.2983 3.87895 10.2287C4.35832 9.28794 5.12322 8.52303 6.06403 8.04367C7.13359 7.4987 8.53372 7.4987 11.334 7.4987H16.6673M16.6673 7.4987L12.5007 11.6654M16.6673 7.4987L12.5007 3.33203"
      stroke="#B0B2B6"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
)
